<template>
  <div
    :class="[
      'shadow-around relative flex h-auto max-h-full w-full flex-col overflow-hidden rounded-lg bg-white pb-1 pt-4 dark:bg-neutral-900 md:rounded-2xl md:pb-3',
      {
        'md:w-100': size === 'sm',
        'md:w-120 md:pt-6': size === 'md',
        'md:w-140': size === 'lg',
      },
    ]"
  >
    <button
      v-if="closable"
      class="size-9 absolute right-2 top-2 flex shrink-0 cursor-pointer items-center justify-center justify-center rounded-lg bg-white px-0 text-gray-500 hover:bg-gray-100 dark:bg-neutral-900 dark:text-neutral-300 dark:hover:bg-neutral-800 md:rounded-xl"
      @click.prevent="closeModal"
    >
      <lucide-icon icon="X" size="22" />
    </button>
    <div class="custom-scroll-y max-h-full w-full grow overflow-auto px-2">
      <div
        class="mx-auto w-full"
        :class="{
          'md:max-w-90': size === 'sm',
          'md:max-w-105': size === 'md',
          'md:w-120': size === 'lg',
        }"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ModalTemplate',
  props: {
    modal: {
      type: Object,
      required: true,
    },
    closable: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'md',
      validator: function (value) {
        return ['sm', 'md', 'lg'].includes(value);
      },
    },
  },
  data() {
    return {};
  },

  watch: {},

  created() {
    window.eventBus.$on('modal:open', () => {
      document.body.classList.add('body-modal-opened');
    });

    window.eventBus.$on('modal:mask-close', () => {
      this.closeModal();
    });
  },

  beforeDestroy() {
    window.eventBus.$off('modal:mask-close');
  },

  methods: {
    ...mapActions(['CLOSE_MODAL']),
    closeModal() {
      if (this.closable) {
        this.CLOSE_MODAL();
      }
    },
  },
};
</script>

<style lang="scss"></style>
